var map = {
	"./Discord.png": 1067,
	"./Facebook.png": 1068,
	"./Footer-Discord.png": 572,
	"./Footer-Facebook.png": 573,
	"./Footer-Medium.png": 574,
	"./Footer-Telegram.png": 575,
	"./Footer-Twitter.png": 576,
	"./Footer-Youtube.png": 577,
	"./Telegram.png": 1069,
	"./Twitter.png": 1070,
	"./Youtube.png": 1071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;